<template>
  <div class="careersApply">
    <top-header></top-header>
    <b-container class="mt-5">
      <b-row>
        <b-col class="px-3 text-left">
          <div class="heading">Contact Us</div>
        </b-col>
      </b-row>
    </b-container> 
	<b-container class="mt-5">
		<b-row>
			<b-col lg="3" md="12" sm="12">
			</b-col>
			<b-col lg="6" md="12" sm="12">
				<div class=" boxshadow p-4 submit-form job-application-form">
					<h3 class="resumator-resume-text">
					Let us know how we can help:  </h3>
				<div class="required-help-text">Required<i class="asterisk">*</i></div>
				
					
				   <!-- <b-form >@submit="onSubmit" @reset="onReset"-->
					  <form ref="form" @submit.stop.prevent="handleSubmitSalseadv">
						<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >Full Name <i class="asterisk">*</i></label>
						 <b-form-group label-for="fullfnameSa-input" label-size="sm" label-class="mb-0" class="mb-3" :state="customerState.fullname" invalid-feedback="First Name is required!"  >
							<b-form-input id="fullfnameSa-input" :state="customerState.fullname" v-model="customer.fullname" @focusin="customerState.fullname = null" size="sm"></b-form-input>
						</b-form-group>
						
						<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >Email Address <i class="asterisk">*</i></label>
						<b-form-group :state="customerState.email"  label-for="emailSa-input" label-size="sm" label-class="mb-0" class="mb-3" invalid-feedback="Email should be valid">
						<b-form-input id="emailSa-input" v-model="customer.email" :state="customerState.email"  @focusin="customerState.email = null" size="sm"></b-form-input>
						</b-form-group>
						
						<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >Phone <i class="asterisk">*</i></label>
						<b-form-group label-for="mobileSa-input" label-size="sm" label-class="mb-0" class="mb-3" :state="customerState.mobile" invalid-feedback="Mobile No is required!" >
						<b-form-input type="tel" id="mobileSa-input" :state="customerState.mobile" v-model="customer.mobile" @focusin="customerState.mobile = null"  maxlength="10" size="sm" @keypress="onlyNumber"></b-form-input>
						</b-form-group>	
						
						<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >Area of Interest  <i class="asterisk">*</i></label>
						<b-form-group label-for="area_Of_interest-input" label-size="sm" label-class="mb-0" class="mb-3" :state="customerState.area_Of_interest" invalid-feedback="This is required!" >
							<b-form-input id="area_Of_interest-input" :state="customerState.area_Of_interest" v-model="customer.area_Of_interest"  @focusin="customerState.area_Of_interest = null" size="sm"></b-form-input>
						</b-form-group>
						
						<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >How can we assist you?  <i class="asterisk">*</i></label>
						<b-form-group label-for="assist-input" label-size="sm" label-class="mb-0" class="mb-3" :state="customerState.assist" invalid-feedback="Last Name is required!" >
							<b-form-input id="assist-input" :state="customerState.assist" v-model="customer.assist"  @focusin="customerState.assist = null" size="sm"></b-form-input>
						</b-form-group>
						
						
						<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >How did you hear about us?  <i class="asterisk">*</i></label>
					<b-form-group :state="customerState.heard_about"  label-for="workareaSa-input" label-size="sm" label-class="mb-0" class="mb-3" invalid-feedback="Work Area is required!">
                    <b-form-select v-model="customer.heard_about" id="workareaSa-input" :state="customerState.heard_about" v-on:change="customerState.heard_about = null" size="sm">
                     
                      <b-form-select-option value=""  selected>*Select Option</b-form-select-option>
                      <b-form-select-option v-for="option in workarea_options" :key="option" :value="option">{{option}}</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
						
						<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >Subject </label>
						<b-form-group label-for="subject-input" label-size="sm" label-class="mb-0" class="mb-3" :state="customerState.subject" invalid-feedback="Subject is required!" >
							<b-form-input id="subject-input" :state="customerState.subject" v-model="customer.subject"  @focusin="customerState.subject = null" size="sm"></b-form-input>
						</b-form-group>
					  
					 
						
						
						
						
						
						
						
						
						
						
						
						<label for="emailSa-input" class="d-block col-form-label-sm mb-0" >Message </label>
						
						
						<b-form-group label-for="message-input" label-size="sm" label-class="mb-0" class="mb-3" :state="customerState.message" invalid-feedback="This is required!" >
							<b-form-textarea
						  id="message-input"
						  v-model="customer.message "
						  rows="1"
						  class="mb-3"
						:state="customerState.message" @focusin="customerState.message = null" ></b-form-textarea>
						</b-form-group>
					
					 
					  <b-row>
						<b-col class="text-center">
						
							<b-button type="submit" variant="danger" size="small" class="w-100" style="background-color: #e94f3d;"> Send Message</b-button>
						</b-col>
					  </b-row>
					<!-- </b-form> -->
				  </form>
				  </div>


					
	  
				</b-col>

		
		</b-row>
    </b-container>
    <div class="about-team py-3">
      <b-container class="mb-3 text-left">
        <p class="text-justify"></p>
      </b-container>
    </div>
    <bottom-footer></bottom-footer>
   
  </div>
</template>

<script>

import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import '../assets/careers.scss';
export default {
  name: "Home",
  components: {
    "top-header": Header,
    "bottom-footer": Footer,
  },
  beforeCreate: function() {
      document.body.className = 'promo';
  },
  mounted(){
		this.init();
	},
  data() {
    return {
      
		submitUrl: this.$root.NEWAPIURL+'profileapi/contactusSave',
	 customer:{
		fullname:'',
		mobile: '',
		email: '',
		area_Of_interest: '',
		assist: '',
		heard_about: '',
		subject: '',
		message:'',
	  },
	  customerState:{
		fullname:null,
		mobile:null,
		email:null,
		area_Of_interest:null,
		assist:null,
		heard_about:null,
		subject:null,
		message:null,
	  },
	  workarea_options:['Advertisement','Press Article','Web Search','Referral','Existing Relationship','Trade Show / Industry Event','Webinar','Other'],
      
     
    
    }
  },
  methods: {
    init(){
      
    },
    validateemail(email){
      var atposition=email.indexOf("@");  
      var dotposition=email.lastIndexOf(".");  
      if (atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length){ 
        return false;  
      }else{
        return true;
      }
    },
	onlyNumber ($event) {
	   //console.log($event.keyCode); //keyCodes value
	   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
	   if(keyCode < 48 || keyCode > 57)  { // 46 is dot
		  $event.preventDefault();
	   }
	},
	checkFormValiditySalseadv() {
		  var valid = true; 
		  
		 
		
		  
		  
		  if(this.customer.fullname==''){
			valid = false;
			this.customerState.fullname = false;
		  }else if(this.customer.fullname.length < 3){
			  valid = false;
			  this.customerState.fullname = false;
		  }else{
		  this.customerState.fullname= true;
		  }
		  
		 
		  
		  if(!this.validateemail(this.customer.email)){
			  valid = false;
			  this.customerState.email = false;
			}else{
			  this.customerState.email = true;
			}
			
			if(this.customer.mobile.length < 10){
			valid = false;
		   this.customerState.mobile = false;
		  }else{
		  this.customerState.mobile = true;
		  }
		  
		  
		 
		  

		 if(this.customer.area_Of_interest==''){
			 valid = false;
			  this.customerState.area_Of_interest = false;      
		  }else{
		  this.customerState.area_Of_interest = true;
		  }

		  if(this.customer.assist==''){
			 valid = false;
			  this.customerState.assist = false;      
		  }else{
			this.customerState.assist = true;
		  }
		  
		  if(this.customer.heard_About==''){
			 valid = false;
			  this.customerState.heard_About = false;      
		  }else{
			this.customerState.heard_About = true;
		  }
		  
		  
		  
		  return valid;
	},
	handleSubmitSalseadv(){
			if (!this.checkFormValiditySalseadv()) {
			return;
			}
			//alert('Test');
		   // return false;
			var self = this;
			
			let formData = new FormData();
					
					formData.append('data', JSON.stringify(this.customer));
					formData.append('accesskey', this.$session.get('access_key'));
					self.axios.post(self.submitUrl, formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							
							self.$bvToast.toast(response.data.message, {
								title: 'Status',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							
							self.customer={
								fullname:'',
								mobile: '',
								email: '',
								area_Of_interest: '',
								assist: '',
								heard_about: '',
								subject: '',
								message:'',
							  };
							  self.customerState={
								fullname:null,
								mobile:null,
								email:null,
								area_Of_interest:null,
								assist:null,
								heard_about:null,
								subject:null,
								message:null,
							  };
							
							//self.product_inf.product_image_1 = '';
							
						}
						
					})
					.catch(function (error) {
						alert(error);
					});

		  },
  },
  metaInfo() {
		return{
			title: 'Alluraa',
			titleTemplate: null,
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'alluraa' },
				{ name: 'description', content: 'alluraa' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
			]
		}
	}
};
</script>
